import Api from '../../api/Api'

const aktifitas = {
  //set namespace true
  namespaced: true,

  //state
  state: {
    akandatang: [],
    telah_selesai: [],
  },

  //mutations
  mutations: {
    SET_WEBINAR_AKAN_DATANG(state, data) {
      state.akandatang = data
    },
    SET_WEBINAR_TELAH_SELESAI(state, data) {
      state.telah_selesai = data
    },
  },

  //actions
  actions: {
    akan_datang({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/aktifitas/akan-datang?per_page=${param.per_page}&page=${param.page}&status=${param.status}&search=${param.search}&flag=${param.flag}&tags=${param.topik}&start=${param.start}&end=${param.end}&flag_status=${param.flag_status}`,
        )
          .then((response) => {
            commit('SET_WEBINAR_AKAN_DATANG', response.data.data.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    telah_selesai({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.get(
          `/aktifitas/akan-datang?per_page=${param.per_page}&page=${param.page}&status=${param.status}&search=${param.search}&flag=${param.flag}&tags=${param.topik}&start=${param.start}&end=${param.end}&flag_status=${param.flag_status}`,
        )
          .then((response) => {
            commit('SET_WEBINAR_TELAH_SELESAI', response.data.data.data)
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    detailaktifitas({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(
          `aktifitas/detailaktifitas/${params.id}?id_aktifitas=${params.id_aktifitas}`,
        )
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    detailaktifitas_workshop({ commit }, params) {
      return new Promise((resolve, reject) => {
        Api.get(
          `aktifitas/detailaktifitas_workshop/${params.id}?id_aktifitas=${params.id_aktifitas}`,
        )
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
    linkMaster({ commit }, param) {
      return new Promise((resolve, reject) => {
        Api.get(`/aktifitas/linkMaster?shortlink=${param.id}`)
          .then((response) => {
            commit('')
            resolve(response)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },
  },
  //getters
  getters: {
    webinar_akan_datang(state) {
      return state.akandatang
    },
    webinar_telah_selesai(state) {
      return state.telah_selesai
    },
  },
}

export default aktifitas
